import {
  featureFlagsConstants,
  featureFlagsListConstants,
  featureAvailableGroupsConstants,
  featureGlobalActivateConstants,
  addFeatureTargetGroupsConstants,
} from "../_redux-constants";
import { featureFlagsService } from "../../_services";
import { errorExtractor } from "../../_helpers";

function getFeatureFlagsList(queryParams) {
  function getFeatureFlagsListLoad() {
    return { type: featureFlagsListConstants.FEATURE_FLAGS_LIST_LOADING };
  }
  function getFeatureFlagsListSuccess(data) {
    return {
      type: featureFlagsListConstants.FEATURE_FLAGS_LIST_SUCCESS,
      data,
    };
  }
  function getFeatureFlagsListFailure(error) {
    return {
      type: featureFlagsListConstants.FEATURE_FLAGS_LIST_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getFeatureFlagsListLoad());
    return featureFlagsService.getFeatureFlagsList(queryParams).then(
      (data) => {
        dispatch(getFeatureFlagsListSuccess(data));
      },
      (error) => {
        dispatch(getFeatureFlagsListFailure(error?.toString()));
      }
    );
  };
}
function getFeatureFlags(requestBody, queryParams) {
  function getFeatureFlagsLoad() {
    return { type: featureFlagsConstants.FEATURE_FLAGS_LOADING };
  }
  function getFeatureFlagsSuccess(data) {
    return {
      type: featureFlagsConstants.FEATURE_FLAGS_SUCCESS,
      data,
    };
  }
  function getFeatureFlagsFailure(error) {
    return {
      type: featureFlagsConstants.FEATURE_FLAGS_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getFeatureFlagsLoad());
    return featureFlagsService.getFeatureFlags(requestBody, queryParams).then(
      (data) => {
        dispatch(getFeatureFlagsSuccess(data));
      },
      (error) => {
        dispatch(getFeatureFlagsFailure(error?.toString()));
      }
    );
  };
}

function getFeatureAvailableGroups(requestBody) {
  function featureAvailableGroupsLoad() {
    return {
      type: featureAvailableGroupsConstants.FEATURE_AVAILABLE_GROUPS_LOADING,
    };
  }
  function featureAvailableGroupsSuccess(data) {
    return {
      type: featureAvailableGroupsConstants.FEATURE_AVAILABLE_GROUPS_SUCCESS,
      data,
    };
  }
  function featureAvailableGroupsFailure(error) {
    return {
      type: featureAvailableGroupsConstants.FEATURE_AVAILABLE_GROUPS_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(featureAvailableGroupsLoad());
    return new Promise((resolve, reject) => {
      featureFlagsService.getFeatureAvailableGroups(requestBody).then(
        (data) => {
          dispatch(featureAvailableGroupsSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(featureAvailableGroupsFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

function featureGlobalActivate(queryParams) {
  function featureGlobalActivateLoad() {
    return {
      type: featureGlobalActivateConstants.FEATURE_GLOBAL_ACTIVATE_LOADING,
    };
  }
  function featureGlobalActivateSuccess(data) {
    return {
      type: featureGlobalActivateConstants.FEATURE_GLOBAL_ACTIVATE_SUCCESS,
      data,
    };
  }
  function featureGlobalActivateFailure(error) {
    return {
      type: featureGlobalActivateConstants.FEATURE_GLOBAL_ACTIVATE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(featureGlobalActivateLoad());
    return new Promise((resolve, reject) => {
      featureFlagsService.featureGlobalActivate(queryParams).then(
        (data) => {
          dispatch(featureGlobalActivateSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(featureGlobalActivateFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

function addFeatureTargetGroups(requestBody, queryParams) {
  function addFeatureTargetGroupsLoad() {
    return {
      type: addFeatureTargetGroupsConstants.ADD_FEATURE_TARGET_GROUPS_LOADING,
    };
  }
  function addFeatureTargetGroupsSuccess(data) {
    return {
      type: addFeatureTargetGroupsConstants.ADD_FEATURE_TARGET_GROUPS_SUCCESS,
      data,
    };
  }
  function addFeatureTargetGroupsFailure(error) {
    return {
      type: addFeatureTargetGroupsConstants.ADD_FEATURE_TARGET_GROUPS_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addFeatureTargetGroupsLoad());
    return new Promise((resolve, reject) => {
      featureFlagsService.addFeatureTargetGroups(requestBody, queryParams).then(
        (data) => {
          dispatch(addFeatureTargetGroupsSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(addFeatureTargetGroupsFailure(error?.toString()));
          errorExtractor(error, reject);
        }
      );
    });
  };
}

export const featureFlagsActions = {
  getFeatureFlagsList,
  getFeatureFlags,
  getFeatureAvailableGroups,
  featureGlobalActivate,
  addFeatureTargetGroups,
};
